import { IconProps } from '@/context/global/types/icon';
import { cn } from '@/context/global/utils/cn';

const IconSearchNotFound = ({ className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="125"
      height="120"
      viewBox="0 0 125 120"
      fill="none"
      className={cn('text-white', className)}
    >
      <path
        d="M108.664 108.447C105.306 106.903 99.5949 102.589 103.626 97.6863C108.664 91.5576 111.117 93.8736 110.434 95.78C109.754 97.6863 104.306 103.545 100.766 98.6395C97.2264 93.7371 100.903 86.3795 102.263 85.9725M0.262695 43.471C0.942783 45.7423 3.34016 49.8176 7.48108 47.9664C12.6566 45.6504 13.8828 42.3813 19.8723 47.9664C24.6671 52.4329 29.0417 48.9196 30.6303 46.6036M99.4058 18.4075C97.9984 15.2749 96.029 9.28019 99.4058 10.3699C103.628 11.7327 96.6828 18.271 88.2382 10.3699"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M66.6955 8.40332L67.4754 10.7035L69.5839 11.5543L67.4754 12.4051L66.6955 14.7053L65.9157 12.4051L63.8071 11.5543L65.9157 10.7035L66.6955 8.40332Z"
        fill="url(#paint0_radial_1_3852)"
      />
      <path
        d="M19.8262 68.2715L20.7137 70.8579L23.1085 71.8163L20.7137 72.7748L19.8262 75.3612L18.9387 72.7748L16.5439 71.8163L18.9387 70.8579L19.8262 68.2715Z"
        fill="#B2D234"
      />
      <path
        d="M40.4907 82.1726L46.811 88.4903L27.6557 107.646C25.9095 109.389 23.0815 109.389 21.3379 107.646C19.5918 105.899 19.5918 103.071 21.3379 101.325L40.4933 82.1699L40.4907 82.1726Z"
        fill="#444444"
      />
      <path
        d="M39.124 84.0264L23.1064 100.044"
        stroke="black"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M47.2015 73.4863L55.4938 81.7787L46.4059 90.8666C45.3792 91.8907 43.717 91.8907 42.693 90.8666L38.1135 86.2872C37.0868 85.2631 37.0868 83.5984 38.1135 82.5743L47.2015 73.4863Z"
        fill="url(#paint1_linear_1_3852)"
      />
      <path
        d="M68.231 91.2627C85.8132 91.2627 100.066 77.0095 100.066 59.4272C100.066 41.845 85.8132 27.5918 68.231 27.5918C50.6487 27.5918 36.3955 41.845 36.3955 59.4272C36.3955 77.0095 50.6487 91.2627 68.231 91.2627Z"
        fill="#444444"
      />
      <path
        d="M68.1166 84.073C81.689 84.073 92.6916 73.0703 92.6916 59.4979C92.6916 45.9255 81.689 34.9229 68.1166 34.9229C54.5441 34.9229 43.5415 45.9255 43.5415 59.4979C43.5415 73.0703 54.5441 84.073 68.1166 84.073Z"
        fill="url(#paint2_linear_1_3852)"
      />
      <path
        d="M82.6924 75.421C91.5256 66.5878 91.5256 52.2639 82.6924 43.4307"
        stroke="#5E5E5E"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.907 44.6396C64.4103 44.6396 63.2155 45.8895 63.2838 47.3863L64.1372 66.0296C64.2002 67.4318 65.3556 68.5346 66.7604 68.5346H67.9394C69.3442 68.5346 70.4969 67.4318 70.5626 66.0296L71.416 47.3863C71.4842 45.8895 70.2895 44.6396 68.7928 44.6396H65.907ZM67.2199 75.8869C68.9608 75.8869 70.3709 74.4768 70.3709 72.7359C70.3709 70.995 68.9608 69.5849 67.2199 69.5849C65.479 69.5849 64.0689 70.995 64.0689 72.7359C64.0689 74.4768 65.479 75.8869 67.2199 75.8869Z"
        fill="#B2D234"
      />
      <path
        d="M112.386 59.3434C113.836 59.3434 115.012 58.1678 115.012 56.7176C115.012 55.2674 113.836 54.0918 112.386 54.0918C110.936 54.0918 109.76 55.2674 109.76 56.7176C109.76 58.1678 110.936 59.3434 112.386 59.3434Z"
        fill="url(#paint3_linear_1_3852)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_1_3852"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(66.685 11.5438) rotate(90) scale(3.15098 2.8884)"
        >
          <stop stopColor="#B2D234" />
          <stop offset="1" stopColor="#B2D234" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_1_3852"
          x1="51.3503"
          y1="77.6325"
          x2="40.4059"
          y2="88.5769"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#111111" />
          <stop offset="1" stopColor="#444444" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_3852"
          x1="92.6916"
          y1="59.4979"
          x2="43.5415"
          y2="59.4979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E9E9E" />
          <stop offset="1" stopColor="#5E5E5E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_3852"
          x1="112.386"
          y1="54.0918"
          x2="112.386"
          y2="59.3434"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B2D234" />
          <stop offset="1" stopColor="#B2D234" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconSearchNotFound;
